import * as types from '../constants/ActionTypes';
export const initialState = {};
export default (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_DEFECTS:
            return {
                ...state,
                [action.payload.repositoryId]: {
                    ...state[action.payload.repositoryId],
                    [action.payload.branchId]: {
                        ...state[action.payload.repositoryId]?.[action.payload.branchId],
                        [action.payload.commitHash]: {
                            ...state[action.payload.repositoryId]?.[action.payload.branchId]?.[action.payload.commitHash],
                            [action.payload.type]: {
                                ...action.payload.defectList,
                                limit: action.payload.limit,
                            },
                        },
                    },
                },
            };
        case types.CLEAR_DEFECTS:
            return {};
        default:
            return state;
    }
};
